import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "form-wrapper slide-up",
  style: {"width":"500px"}
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = {
  key: 0,
  style: {"margin-bottom":"15px"}
}
const _hoisted_5 = {
  key: 1,
  style: {"margin-bottom":"15px"}
}
const _hoisted_6 = { class: "my-checklists-label" }
const _hoisted_7 = {
  key: 2,
  class: "who-can-view-list",
  style: {"margin-bottom":"20px"}
}
const _hoisted_8 = { class: "my-checklists-label" }
const _hoisted_9 = {
  key: 3,
  class: "who-can-view-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×")
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Who Can View", -1)),
          (_ctx.node.DepartmentsJSON.length == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.node.Name) + " is tagged to the ", 1),
                _createElementVNode("b", null, _toDisplayString(_ctx.node.DeparmentsString), 1),
                _cache[1] || (_cache[1] = _createTextVNode(" department. Anyone assigned to that department can see it. ", -1))
              ]))
            : (_ctx.node.DepartmentsJSON.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_ctx.node.Name) + " is tagged to these departments: ", 1),
                  _createElementVNode("b", null, _toDisplayString(_ctx.node.DeparmentsString) + ".", 1),
                  _cache[2] || (_cache[2] = _createTextVNode(" Anyone assigned to those departments can see it. ", -1))
                ]))
              : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, "STANDARD USERS (" + _toDisplayString(_ctx.nodePublicUsers.length) + ")", 1),
          (_ctx.nodePublicUsers.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodePublicUsers, (u, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(u.FirstName) + " " + _toDisplayString(u.LastName), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, "ADMINS & EDITORS (" + _toDisplayString(_ctx.nodeUsers.length) + ")", 1),
          (_ctx.nodeUsers.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodeUsers, (u, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(u.FirstName) + " " + _toDisplayString(u.LastName), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}